import { QueryFunctionContext, QueryKey, useInfiniteQuery, UseInfiniteQueryOptions } from "@tanstack/react-query";
import { chatClient } from "@core/clients";
import { OrderChatCursor, OrderChatMessagesPage } from "@core/types";
import { orderChatQueryKeys } from "./keys";
import { ORDER_CHAT_PAGE_SIZE } from "./constants";

type Options = Omit<UseInfiniteQueryOptions<OrderChatMessagesPage>, "queryKey" | "queryFn" | "getNextPageParam">;

const useOrderChatMessagesQuery = (chatId: number | undefined, options?: Options) => {
  const query = useInfiniteQuery<OrderChatMessagesPage>(
    orderChatQueryKeys.messages(chatId ?? 0),
    (ctx: QueryFunctionContext<QueryKey, OrderChatCursor | undefined>) =>
      chatClient.getOrderChatMessages({
        chatId: chatId as number,
        before: ctx.pageParam,
        limit: ORDER_CHAT_PAGE_SIZE,
      }),
    {
      enabled: !!chatId,
      getNextPageParam: (lastPage) => lastPage.nextCursor ?? undefined,
      ...options,
    },
  );

  return query;
};

export default useOrderChatMessagesQuery;
